import { BlockCard } from "src/modules/worksheet/components/WorksheetEditor/components/Editor";

const renderCardLongAnswer = (props: any) => {
    return <BlockCard {...props}>Long Answer Block</BlockCard>;
};

export default renderCardLongAnswer;
